import { retryAfterSeconds } from './httpResponse.js';

export function createCardCarouselRequestGuard(now = Date.now) {
    let blockedUntil = 0;
    const pendingTriggers = new WeakMap();
    const isCarousel = (element) => element?.matches?.('[data-card-carousel]');

    return {
        canQueue({ elt, triggeringEvent } = {}) {
            if (!isCarousel(elt)) return true;
            if (pendingTriggers.has(elt)) {
                // htmx reissues the original event when draining its queue.
                return pendingTriggers.get(elt) === triggeringEvent;
            }
            pendingTriggers.set(elt, triggeringEvent);
            return true;
        },

        canRequest(element) {
            if (!isCarousel(element) || now() >= blockedUntil) return true;
            pendingTriggers.delete(element);
            return false;
        },

        afterRequest({ elt, xhr } = {}) {
            if (!isCarousel(elt)) return;
            pendingTriggers.delete(elt);
            if (![429, 503].includes(xhr?.status)) {
                return;
            }

            const delay = retryAfterSeconds(
                xhr.getResponseHeader('Retry-After'),
                now()
            );
            // Stop the queued decorative requests during the gateway cooldown.
            // Static images and listing links remain available; no automatic retry.
            blockedUntil = Math.max(blockedUntil, now() + (delay ?? 10) * 1000);
        }
    };
}
